import { React } from 'react';
import TextField from '@mui/material/TextField';
import { Cancel, Help, Save } from '@mui/icons-material';
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';
import {
	Box,
	Button,
	FormControl,
	FormHelperText,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	Tooltip,
	Typography,
	useMediaQuery,
} from '@mui/material';
import useDisableNumberInputScroll from '../../hooks/useDisableNumberInputScroll';
import { Controller, useForm } from 'react-hook-form';

export default function ProductCreate({ product }) {
	useDisableNumberInputScroll();
	const smBreakpoint = useMediaQuery((theme) => theme.breakpoints.down('lg'));
	const lgBreakpoint = useMediaQuery((theme) => theme.breakpoints.up('lg'));

	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm({
		defaultValues: {
			type: '',
		},
	});
	const onSubmit = (data) => console.log(data);

	console.log(errors);

	//https://www.npmjs.com/package/react-hook-form-mui
	//https://react-hook-form-material-ui.vercel.app/?path=/story/formcontainer--with-error-handler

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Box sx={{ padding: 2 }}>
				<Grid container gap={2} sx={{ flexDirection: 'row' }}>
					<Grid size={{ xs: 12, lg: 10 }}>
						<Typography variant='h6' sx={{ marginBottom: 2 }}>
							{product ? 'Edit' : 'Create'} Product
						</Typography>
						<Grid container spacing={2}>
							<Grid container size={{ xs: 12, lg: 12, xl: 8 }}>
								<Grid size={{ xs: 12, sm: 8 }}>
									<FormControl fullWidth>
										<TextField
											error={errors.name}
											name='name'
											label='Name*'
											variant='outlined'
											{...register('name', {
												required: 'Name is required',
											})}
										/>
										{errors.name && (
											<FormHelperText
												error={
													errors.name ? true : false
												}
											>
												{errors.name.message}
											</FormHelperText>
										)}
									</FormControl>
								</Grid>

								<Grid size={{ xs: 6, sm: 4 }}>
									<Controller
										name='type'
										control={control}
										type='text'
										rules={{
											required: 'Select product type',
										}}
										defaultValue={[]}
										render={(field) => (
											<Grid>
												<FormControl fullWidth>
													<InputLabel id='type'>
														Type*
													</InputLabel>
													<Select
														{...field.field}
														label='Type*'
														name='type'
														defaultValue={[]}
														error={errors.type}
														sx={{
															minWidth: '150px',
														}}
													>
														<MenuItem
															key={'beverage'}
															value={'beverage'}
														>
															Beverage
														</MenuItem>
														<MenuItem
															key={'food'}
															value={'food'}
														>
															Food
														</MenuItem>
														<MenuItem
															key={'hotDrink'}
															value={'hotDrink'}
														>
															Hot Drink
														</MenuItem>
														<MenuItem
															key={'ingredient'}
															value={'ingredient'}
														>
															Ingredient
														</MenuItem>
													</Select>
													{errors.type && (
														<FormHelperText error>
															{
																errors.type
																	.message
															}
														</FormHelperText>
													)}
												</FormControl>
											</Grid>
										)}
									/>
								</Grid>

								<Grid size={6}>
									<FormControl fullWidth>
										<TextField
											error={errors.code}
											name='code'
											label='Code*'
											{...register('code', {
												required: 'Code is required',
											})}
											variant='outlined'
											sx={{ width: '100%' }}
										/>
										{errors.code && (
											<FormHelperText
												error={
													errors.code ? true : false
												}
											>
												{errors.code.message}
											</FormHelperText>
										)}
									</FormControl>
								</Grid>

								<Grid size={{ xs: 12, sm: 6 }}>
									<FormControl fullWidth>
										<TextField
											error={
												errors.barcode ? true : false
											}
											{...register('barcode', {
												pattern: {
													value: /^[0-9]*$/g,
													message:
														'Barcode must include numbers only',
												},
											})}
											name='barcode'
											label='Barcode'
											variant='outlined'
										/>
										{errors.barcode && (
											<FormHelperText error>
												{errors.barcode.message}
											</FormHelperText>
										)}
									</FormControl>
								</Grid>

								<Grid size={{ xs: 12, lg: 4 }}>
									<FormControl fullWidth>
										<TextField
											error={
												errors.unitsPerCase
													? true
													: false
											}
											{...register('unitsPerCase', {
												pattern: {
													value: /^[0-9]*$/g,
													message:
														'Simple numbers only (1, 50, etc.)',
												},
											})}
											label='Units Per Case'
											variant='outlined'
											slotProps={{
												htmlInput: {
													inputMode: 'numeric',
												},
											}}
										/>
										{errors.unitsPerCase && (
											<FormHelperText error>
												{errors.unitsPerCase.message}
											</FormHelperText>
										)}
									</FormControl>
								</Grid>

								<Grid size={{ xs: 12, sm: 6, lg: 4 }}>
									<FormControl fullWidth>
										<TextField
											label='Reorder Point'
											name='reorderPoint'
											variant='outlined'
											slotProps={{
												htmlInput: {
													inputMode: 'numeric',
												},
												input: {
													endAdornment: (
														<InputAdornment position='end'>
															<Tooltip title='A reorder point is the threshold (in single units) when you should reorder more of a product'>
																<IconButton>
																	<Help />
																</IconButton>
															</Tooltip>
														</InputAdornment>
													),
												},
											}}
										/>
										<FormHelperText id='outlined-weight-helper-text'>
											Minimum quantity
										</FormHelperText>
									</FormControl>
								</Grid>

								<Grid size={{ xs: 12, sm: 6, lg: 4 }}>
									<FormControl fullWidth>
										<TextField
											label='Order Up to Level'
											name='TextField'
											variant='outlined'
											slotProps={{
												htmlInput: {
													inputMode: 'numeric',
												},
												input: {
													endAdornment: (
														<InputAdornment position='end'>
															<Tooltip title='Enter the quantity on hand (in single units) in your warehouse'>
																<IconButton>
																	<Help />
																</IconButton>
															</Tooltip>
														</InputAdornment>
													),
												},
											}}
										/>
										<FormHelperText id='outlined-weight-helper-text'>
											Maximum quantity
										</FormHelperText>
									</FormControl>
								</Grid>
							</Grid>

							<Grid size={{ xs: 12, lg: 12, xl: 4 }}>
								<Grid component='fieldset'>
									<legend>Initial Inventory Setup</legend>
									<Grid container spacing={2}>
										<Grid size={{ xs: 12, lg: 6, xl: 12 }}>
											<FormControl fullWidth>
												<TextField
													name='initialQuantity'
													label='Quantity (single units)'
													variant='outlined'
													slotProps={{
														htmlInput: {
															inputMode:
																'numeric',
														},
														input: {
															endAdornment: (
																<InputAdornment position='end'>
																	<Tooltip title='Enter the quantity on hand (in single units) in your warehouse'>
																		<IconButton>
																			<Help />
																		</IconButton>
																	</Tooltip>
																</InputAdornment>
															),
														},
													}}
												/>
											</FormControl>
										</Grid>
										<Grid size={{ xs: 12, lg: 6, xl: 12 }}>
											<FormControl fullWidth>
												<TextField
													name='initialUnitCost'
													label='Unit Cost'
													variant='outlined'
													slotProps={{
														htmlInput: {
															inputMode:
																'decimal',
														},
														input: {
															endAdornment: (
																<InputAdornment position='end'>
																	<Tooltip title='Enter the the purchase cost of a single item'>
																		<IconButton>
																			<Help />
																		</IconButton>
																	</Tooltip>
																</InputAdornment>
															),
														},
													}}
												/>
											</FormControl>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>

					<Grid
						container
						sx={{
							gap: { xs: 0, sm: 3, lg: 1 },
							flexDirection: { xs: 'row', lg: 'column' },
							justifyContent: {
								xs: 'space-around',
								sm: 'end',
								lg: 'start',
							},
							paddingTop: { xs: 2, lg: 0 },
							paddingLeft: { xs: 0, lg: 2 },
							borderLeft: { xs: 0, lg: '1px solid gray' },
						}}
						size={'grow'}
					>
						<Typography
							variant='h6'
							sx={{ display: { xs: 'none', lg: 'block' } }}
						>
							Actions
						</Typography>
						<Button
							sx={{
								justifyContent: 'left',
								textTransform: 'none',
								paddingLeft: { sm: 2, lg: 0 },
							}}
							size='large'
							variant={
								smBreakpoint
									? 'outlined'
									: lgBreakpoint && 'text'
							}
							tabIndex={-1}
							startIcon={<Save />}
							type='submit'
						>
							Save
						</Button>
						<Button
							to='/products'
							component={Link}
							sx={{
								justifyContent: 'left',
								textTransform: 'none',
								paddingLeft: { sm: 2, lg: 0 },
							}}
							size='large'
							variant={
								smBreakpoint
									? 'outlined'
									: lgBreakpoint && 'text'
							}
							color={'error'}
							tabIndex={-1}
							startIcon={<Cancel />}
						>
							Cancel
						</Button>
					</Grid>
				</Grid>
			</Box>
		</form>
	);
}
